const bundle = {
  close: () => 'Закрити',
  error: () => 'Помилка',
  warn: () => 'Попередження',
  info: () => 'Відомості',
  confirmation: () => 'Підтвердження',
  progressIndeterminate: () => 'Триває',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Від ' + p['FROM_SECTION'] + ' до ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Не знайдено відповідних розділів.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Натисніть клавішу Enter, щоб вибрати значення.',
  indexer_touchInstructionText: () =>
    'Двічі торкніться й утримайте, щоб увійти в режим жестів, а потім перетягніть угору або вниз, щоб змінити значення.',
  inputPassword_show: () => 'Показати пароль',
  inputPassword_hide: () => 'Приховати пароль',
  inputPassword_hidden: () => 'Пароль приховано',
  formControl_clear: () => 'Очистити',
  formControl_loading: () => 'Завантаження',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Максимальну довжину (' + p['MAX_LENGTH'] + ') перевищено.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Залишилася така кількість символів: ' + p['CHARACTER_COUNT'] + '.',
  select_noMatchesFound: () => 'Збігів не знайдено.',
  select_oneMatchFound: () => 'Знайдено один збіг',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено таку кількість збігів: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Знайдено ' + p['TOTAL_SIZE'] + ' або більше збігів',
  selectMultiple_showSelectedValues: () => 'Показувати лише вибрані значення.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Вибрано таку кількість значень: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Прапорець установлено',
  selector_unselected: () => 'Прапорець не встановлено',
  userAssistance_learnMore: () => 'Додаткові відомості',
  userAssistance_required: () => "Обов'язково",
  filePicker_singleFileUploadError: () => 'Передайте один файл за раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Неможливо передати файл типу ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Неможливо передати файли типів ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'невідомо',
  filePicker_dropzonePrimaryText: () => 'Перетягнути',
  filePicker_dropzoneSecondaryText: () => 'Виберіть файл або перетягніть його сюди',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Виберіть файли або перетягніть їх сюди',
  filePicker_addFiles: () => 'Додати файли',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Збільшення',
  inputNumber_decrease: () => 'Зменшення',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Немає позицій для відображення',
  message_navigationFromMessagesRegion: () =>
    'Вхід в область повідомлень. Натисніть клавішу F6, щоб повернутися до елемента, на якому раніше було встановлено фокус.',
  message_navigationToMessagesRegion: () =>
    'В області повідомлень наявні нові повідомлення. Натисніть клавішу F6, щоб перейти до останньої області повідомлень.',
  messageToast_allMessagesClosed: () => 'Усі спливні повідомлення закрито.'
};
export default bundle;
